import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import moment from "moment";
import { BsX } from "react-icons/bs";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
import { Tooltip } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import CloudIcon from "assets/svgs/cloud_icon";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  revenueRepStartDate,
  revenueRepEndDate,
  getFormattedStartDate,
  getFormattedEndDate,
} from "functionCall";
import { formatDate, isDownloadDisabled } from "modules/utilities/utility";
import { isEmpty } from "lodash";

function FilterDownload(props) {
  const [startDate, setStartDate] = useState(new Date(Date.now()));
  const [endDate, setEndDate] = useState(new Date());
  const navigation = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (startDate && endDate) {
      navigation(
        `/medRep-engagement?id=${id}&sd=${moment(startDate).startOf('days').toISOString()}&ed=${moment(endDate).endOf('days').toISOString()}`
      );
    } else {
      navigation(
        `/medRep-engagement?id=${id}&sd=${revenueRepStartDate(
          getFormattedEndDate(1)
        )}&ed=${revenueRepEndDate(getFormattedStartDate())}`
      );
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };
  const handleResetStartDate = () => {
    setStartDate("");
  };
  const handleResetEndDate = () => {
    setEndDate("");
  };

  const handleDownload = async () => {
    const medRepName = props.medRepName;
    if (typeof medRepName !== "string") return;

    const csvFileName = `engagements-${medRepName
      .toLowerCase()
      .replaceAll(" ", "_")}.csv`;

    try {
      await downloadCSV(null, props.data, csvFileName);
    } catch (error) {
      console.error(error);
    }
  };

  const downloadCSV = async (status, data, csvName) => {
    try {
      const csvString = Papa.unparse(data);
      const url = window.URL.createObjectURL(
        new Blob([csvString], { type: "text/csv" })
      );
      const anchorTag = document.createElement("a");
      anchorTag.href = url;
      anchorTag.target = "_blank";
      anchorTag.download = csvName;
      document.body.appendChild(anchorTag);
      anchorTag.click();
      document.body.removeChild(anchorTag);
      window.URL.revokeObjectURL(url);
      return Promise.resolve("success");
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return (
    <div>
      <div className="d-flex gap-2">
        <Form.Group>
          <div className="input-container mt-2">
            {startDate ? (
              ""
            ) : (
              <div className="calendar-icon-container">
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  className="calendar-icon"
                />
              </div>
            )}
            <DatePicker
              selected={startDate}
              onChange={handleStartDateChange}
              placeholderText="Start Date"
              dateFormat="dd-MM-yyyy"
              value={startDate ? formatDate(startDate) : ""}
              className="input-with-icon"
            />
            {startDate && (
              <span className="reset-icon" onClick={handleResetStartDate}>
                <BsX />
              </span>
            )}
          </div>
        </Form.Group>
        <Form.Group>
          <div className="input-container mt-2">
            {endDate ? (
              ""
            ) : (
              <div className="calendar-icon-container">
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  className="calendar-icon"
                />
              </div>
            )}
            <DatePicker
              selected={endDate}
              onChange={handleEndDateChange}
              placeholderText="End Date"
              dateFormat="dd-MM-yyyy"
              value={endDate ? formatDate(endDate) : ""}
            />
            {endDate && (
              <span className="reset-icon" onClick={handleResetEndDate}>
                <BsX />
              </span>
            )}
          </div>
        </Form.Group>

        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fw-bold">Filter by Date</div>
            </Tooltip>
          }
        >
          <Button
            variant="primary"
            className="mt-2 float-end"
            onClick={handleFilterSubmit}
            style={{ height: "2.15rem" }}
          >
            Filter
          </Button>
        </OverlayTrigger>
        <div className="d-flex justify-content-center">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Download Data</div>
              </Tooltip>
            }
          >
            <Button
              type="primary"
              onClick={handleDownload}
              size="medium"
              className="mt-2"
              style={{ height: "2.1rem" }}
              disabled={isDownloadDisabled || (!props.data || isEmpty(props.data))}
            >
              <div>
                <CloudIcon />{" "}
              </div>
            </Button>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  );
}

export default FilterDownload;
